import React from 'react';
import { WithFlyout } from '@amzn/atoz-web/Flyout';
export var FlyoutWrapper = function (_a) {
    var renderButton = _a.renderButton, renderContent = _a.renderContent;
    return (React.createElement(WithFlyout, { dataTestId: "flyout-wrapper", renderFlyout: renderContent }, renderButton));
};
